<template>
  <div>
    <div class="row b-form__row_type_flex-end">
      <div class="col-4" :class="{'col-8': isEdit}">
        <div class="b-form__container">
          <label v-if="!isEdit">{{$t('CONTENT.assets.asset_choose')}}:<span class="b-form__required"> *</span></label>
          <label v-else>{{$t('CONTENT.assets.asset_choose_without_creating')}}:<span class="b-form__required"> *</span></label>
          <cool-select :list="availableAssetIds"
                       option-value="idInDB"
                       option-text="name"
                       :isError="isError"
                       :placeholder="$t('CONTENT.choose')"
                       v-model="currentAsset"></cool-select>
        </div>
      </div>
      <div class="col-1" v-if="!isEdit">
        <button type="button" data-cy="create-new-asset" class="b-btn b-btn_type_add" @click="openAssetCreateDialog">
          <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
        </button>
      </div>
    </div>
    <div v-if="isAssetChoose">
      <div class="row mt-5">
        <div class="col-2" :class="{'col-4': isEdit}">
          <div class="b-form__container" data-cy="asset-type">
            <label>{{$t('CONTENT.assets.base_asset_type')}}:</label>
            {{underlyingAssetTypeName}}
          </div>
        </div>
        <div class="col-2" :class="{'col-4': isEdit}">
          <div class="b-form__container">
            <label>{{$t('CONTENT.external_id')}}:</label>
            {{externalId}}
          </div>
        </div>
      </div>
    </div>
    <popup :name="`asset-popup-${currentAssetId}`" height="auto" :scrollable="true">
      <div data-cy="form-label" class="b-dialog__top-panel">
        <h2>{{$t('CONTENT.assets.asset_create')}}</h2>
        <button class="b-btn b-btn_border_none" @click.prevent="closeAssetCreateDialog">
          <dynamic-icon icon="close" />
        </button>
      </div>
      <CreateAsset v-if="ifAssetCreateModal" @closeDialog="closeAssetCreateDialog" @createAsset="onCreateAsset"></CreateAsset>
    </popup>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import CreateAsset from "../registry/contracts/create/assets/CreateAsset";
  export default {
    props: {
      currentAssetId: {
        type: Number,
      },
      availableAssetIds: {
        type: Array,
        required: true,
      },
      isError: {
        type: Boolean
      },
      isEdit: {
        type: Boolean
      }
    },
    components: {
      CreateAsset,
    },
    data() {
      return {
        assetId: null,
        underlyingAssetTypeName: null,
        assetName: null,
        externalId: null,
        isAssetChoose: false,
        ifAssetCreateModal: false,
      }
    },
    created() {
      if (this.currentAssetId !== undefined) {
        this.assetId = this.currentAssetId;
      }
    },
    computed: {
      ...mapGetters(['getUnderlyingAssetTypes']),
      ...mapGetters(['getAssets']),
      currentAsset: {
        get() {
          return this.assetId;
        },
        set(newVal) {
          this.assetId = newVal;
        }
      },
      assets() {
        return this.getAssets;
      },
      underlyingAssetTypes() {
        return this.getUnderlyingAssetTypes;
      },
    },
    watch: {
      currentAsset(newVal, oldVal) {
        this.setCurrentAssetInfo(newVal);
        this.$emit('selectedAssetId', {currentAssetId: newVal, oldAssetId: oldVal});
      },
      currentAssetId(newVal) {
        if (newVal !== undefined) {
          this.assetId = newVal;
        }
      }
    },
    methods: {
      setCurrentAssetInfo(id) {
        const asset = this.assets.find(a => a.idInDB === id);
        this.assetName = asset.name;
        this.externalId = asset.externalId;
        const underlyingAssetType = this.underlyingAssetTypes.find(a => a.idInDb === asset.underlyingAssetTypeId);
        this.underlyingAssetTypeName = underlyingAssetType.name;
        this.isAssetChoose = true;
      },

      openAssetCreateDialog() {
        this.ifAssetCreateModal = true;
        this.$modal.show(`asset-popup-${this.currentAssetId}`);
      },
      closeAssetCreateDialog() {
        this.ifAssetCreateModal = false;
        this.$modal.hide(`asset-popup-${this.currentAssetId}`);
      },
      onCreateAsset(newAsset) {
        this.setCurrentAssetInfo(newAsset.idInDB);
        this.$emit('createAssetId', {newAssetId: newAsset.idInDB, oldAssetId: this.assetId});
      },
    }
  }
</script>
